import React from 'react'
import { useLocalization } from '../../hooks/useLocalization'

/**
 * Partnership Hero Section Component
 * 
 * Displays the main partnership messaging on the Home Page
 */
const PartnershipHeroSection: React.FC = () => {
  const { t } = useLocalization()

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white dark:bg-gray-900">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 dark:text-gray-100 mb-6">
          {t('home.partnership.hero.title')}
        </h2>
        <p className="text-xl sm:text-2xl text-gray-600 dark:text-gray-300 max-w-4xl mx-auto leading-relaxed">
          {t('home.partnership.hero.subtitle')}
        </p>
      </div>
    </section>
  )
}

export default PartnershipHeroSection
